import React from 'react';
import PropTypes from 'prop-types';
import styles from './NumberedList.module.less';

const NumberedList = ({ ecmContent }) => {
  const { jsonObject } = ecmContent || {};
  const { list } = jsonObject || {};

  return (
    <div className={styles.container}>
      <div className={styles.steps}>
        {list.map((item, index) => (
          <div key={index} className={styles.steps_wrapper}>
            <div className={styles.custom_badge}>
              <p className={styles.custom_badge_text}>{index + 1}</p>
            </div>
            <div className={styles.text} dangerouslySetInnerHTML={{ __html: `<p>${item} </p>` }} />
          </div>
        ))}
      </div>
    </div>
  );
};

NumberedList.propTypes = {
  ecmContent: PropTypes.object.isRequired
};

export default NumberedList;
